module.exports = __webpack_public_path__ + "app/principal/principal-check-config-1Upxgd9-.html";